import React from "react";
import { Modal, Spinner } from "react-bootstrap";
import icon from "../../../assets/redeem-modal-icon.png";
function ConfirmRedeemModal({
  show,
  handleClose,
  handleRedeem,
  isLoading,
  listItemsLength,
}) {
  return (
    <Modal
      show={show}
      //   onHide={handleClose}
      centered
      onHide={handleClose}
      className={`delete-schedule-modal`}
    >
      <Modal.Body className="delete-schedule-modal-body">
        <div className="d-flex flex-column align-items-center justify-content-center">
          <div className="confirm-redeem-modal-icon-container mt-2 mb-4">
            <img src={icon} alt="icon" className="confirm-redeem-modal-icon" />
          </div>
          <p className="delete-text-sub-label">
            Are you sure, you want to redeem {listItemsLength} bookings?
          </p>
          <div className="delete-modal-btn-group d-flex">
            <button className="delete-schedule-cancel" onClick={handleClose}>
              Cancel
            </button>
            <button
              onClick={handleRedeem}
              disabled={isLoading}
              className="delete-schedule-confirm"
            >
              Redeem {isLoading && <Spinner size="sm" className="ms-2" />}
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default ConfirmRedeemModal;
